<script setup lang="ts">
import type { PropType } from "vue";

const props = defineProps({
  label: { type: String, required: true },

  value: { type: String, required: true },
  color: { type: String, required: false },

  modelValue: {
    type: Array as PropType<string[]>,
    required: true,
  },

  colorClass: {
    type: Object as PropType<Record<string, boolean>>,
    required: false,
  },
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();

function toggle(value: string) {
  const newValue = props.modelValue.includes(value)
    ? props.modelValue.filter((v) => v !== value)
    : [...props.modelValue, value];

  emit("update:modelValue", newValue);
}
</script>

<template>
  <label
    class="flex items-center gap-2 cursor-pointer select-none text-gray-700 text-sm"
  >
    <input
      type="checkbox"
      :checked="modelValue.includes(value)"
      @change="toggle(value)"
      class="cursor-pointer"
    />

    <span
      class="w-2.5 h-2.5 rounded-full inline-block"
      :style="{ backgroundColor: color }"
      :class="colorClass"
    ></span>

    {{ label }}
  </label>
</template>
